export const formatDateGerman = (datetime: string) => {
  const date = new Date(datetime)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${day}.${month}.${date.getFullYear()}`
}

export const formatDateTimeGerman = (datetime: string) => {
  /**
   * Formats a datetime string in ISO 8601 format to a
   * string germans typically use to display dates and times.
   *
   * @param {string} datetime - The datetime string to format
   * @returns {string} The formatted datetime string
   */
  const date = new Date(datetime)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear()).slice(2)
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}.${month}.${year}, ${hours}:${minutes} Uhr`
}
